// Definimos a versão da api que está sendo utilizada em todas as requisições
import { version } from './config';

export default {
  assinarPremium(payload) {
    return axiosWithoutLoading.post(`/api/${version}/assinatura`, payload);
  },
  cancelarAssinatura() {
    return axios.post(`/api/${version}/assinatura/cancelar`);
  },
  faturas() {
    return axiosWithoutLoading.get(`/api/${version}/assinatura/recibos`);
  },
  reativarAssinatura() {
    return axios.post(`/api/${version}/assinatura/reativar`);
  },
  atualizarDadosCartao(payload) {
    return axios.post(`/api/${version}/assinatura/atualizar-dados-cartao`, payload);
  },
  getPlanos() {
    return axiosWithoutLoading.get(`/api/${version}/planos`);
  },
  getDadosCobranca() {
    return axios.get(`/api/${version}/assinatura/dados-cobranca`);
  },
  atualizarDadosCobranca(payload) {
    return axios.post(`/api/${version}/assinatura/atualizar-dados-cobranca`, payload);
  },
}
